<template>
  <Modal
    class="max-modal detail-modal"
    :mask-closable="false"
    :closable="false"
    title="商品详情"
    v-model="modal">
    <div class="box-detail">
      <div class="box-detail__img">
        <img :src="detail.imageBase64" alt="">
        <img :src="defaultImageShow" alt="" v-if="!detail.imageBase64">
      </div>
      <div class="box-detail__info">
        <h3>{{ detail.commodityName }}<Tag color="cyan" v-if="detail.useState">已上架</Tag><Tag v-else color="red">已下架</Tag></h3>
        <ul>
          <li><span>商品编号：</span><p>{{ detail.id }}</p></li>
          <li><span>商品类别：</span><p>{{ detail.labelName }}</p></li>
          <li><span>商品状态：</span><p>{{ detail.useState? '已上架' : '已下架' }}</p></li>
          <li><span>商品价格：</span><p>{{ detail.facePrice + '元' }}</p></li>
          <li><span>成本折扣：</span><p>{{ detail.costDiscount + '%' }}</p></li>
          <li><span>税点：</span><p>{{ detail.taxPoint + '%' }}</p></li>
          <li><span>商品备注：</span><p>{{ detail.remark }}</p></li>
          <li><span>创建时间：</span><p>{{ detail.createDate | dateTime }}</p></li>
          <li><span>更新时间：</span><p>{{ detail.updateDate | dateTime }}</p></li>
          <li><span>类型：</span><p> 实时订购</p></li>
          <!-- <li><span>可用开始时间：</span><p>{{ detail.createDate | dateTime }}</p></li>
          <li><span>可用结束时间：</span><p>{{ detail.updateDate | dateTime }}</p></li> -->
          <li class="hr"></li>
          <li><span>供应商：</span><p>{{ detail.supplierName }}</p></li>
          <li><span>供应商商品名称：</span><p>{{ detail.supplierCommodityName }}</p></li>
          <li><span>供应商商品编号：</span><p>{{ detail.supplierCommodityNo }}</p></li>
        </ul>
      </div>
    </div>
    <div slot="footer">
      <Button type="primary" @click="hide">关闭</Button>
    </div>
  </Modal>
</template>

<script>
import defaultImage from '../../assets/img/commodity-image.png'

export default {
  name: 'CommodityDetail',
  data () {
    return {
      modal: false,
      detail: {},
      defaultImageShow: ''
    }
  },
  methods: {
    show (data = {}) {
      this.defaultImageShow = defaultImage
      data.imageBase64 = data.imageBase64 || ''
      this.detail = data
      this.modal = true
    },
    hide () {
      this.modal = false
    }
  }
}
</script>
<style scope>
  .box-detail__info li span {
    width: 120px;
  }
  .box-detail__info li p {
    margin-left: 120px
  }
</style>
